// Things the run can be handed mid-flight: charms (deals, the Wheel) and Night Shifts.
import { CHARM_LIST } from '../content/registry';
import { say } from './dialogue';
import type { Modifiers } from './modifiers';
import type { Rng } from './rng';
import type { GameEvent, GameState, Rarity } from './types';

/** A random charm of that rarity the run doesn't own (never cursed). */
export function giveCharm(state: GameState, mods: Modifiers, rarity: Rarity, rng: Rng, by: string, events: GameEvent[]): string | null {
  const run = state.run!;
  const pool = CHARM_LIST.filter((c) => c.rarity === rarity && !c.cursed && !run.charms.includes(c.id) && (!c.requires || c.requires(mods)));
  if (!pool.length) return null;
  const id = rng.pick(pool).id;
  run.charms.push(id);
  if (!state.meta.almanac.charms.includes(id)) state.meta.almanac.charms.push(id);
  events.push({ e: 'CHARM_GAINED', id, by });
  return id;
}

/** Night Shift (docs/04 §17.3): free spins with a sticky Grin column that walks right. */
export function startNightShift(state: GameState, mods: Modifiers, spins: number, events: GameEvent[]): void {
  const run = state.run!;
  const left = (run.nightShift?.left ?? 0) + spins + mods.nightShiftBonus;
  run.nightShift = { left, wild: run.nightShift?.wild ?? 0 };
  events.push({ e: 'NIGHT_SHIFT', left, wild: run.nightShift.wild });
  say(state, 'nightShift', events, undefined, { force: true });
}
